import Parse from "parse/lib/browser/Parse"


export const fetchConfig = () => {
  const config = Parse.Object.extend('Config');
  const query = new Parse.Query(config);
  return query.find()
}
